import { render, staticRenderFns } from "./VentasPorArticulo.vue?vue&type=template&id=0b04cc0c&"
import script from "./VentasPorArticulo.vue?vue&type=script&lang=js&"
export * from "./VentasPorArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports